import type { GameLinkKind } from "libs/apiClient";

/** React Query key segment for `getDiscoverGameV2` detail (see `DiscoverGamePageV2`). */
export const DISCOVER_GAME_V2_DETAIL_QUERY_KEY = "discoverGameV2Detail";

/** Aligns with `Eyeball\Enum\Game\GameLinkKind` / `GameLinkKind` in apiClient. */
export const DiscoverGameLinkKind = {
	Teamsheet: "teamsheet",
	Video: "video",
} as const satisfies Record<string, GameLinkKind>;

/**
 * Discover game PATCH `requestedFields` values editable from the basic metadata form
 * (subset of `DiscoverGamePatchFieldEnum`).
 */
export enum DiscoverGameBasicPatchField {
	Date = "date",
	HomeScore = "homeScore",
	AwayScore = "awayScore",
	Type = "type",
	LeagueId = "leagueId",
	AgeCategory = "ageCategory",
	OwnerIds = "ownerIds",
	IsVip = "isVip",
	IsHidden = "isHidden",
	IsHiddenForScout = "isHiddenForScout",
	HomeTeamStartsOnLeft = "homeTeamStartsOnLeft",
}

/** Select values for the tri-state `homeTeamStartsOnLeft` field (UI-only; the API takes a nullable boolean). */
export enum StartsOnLeftSelectValue {
	Home = "home",
	Away = "away",
	Unset = "unset",
}

const STARTS_ON_LEFT_SELECT_VALUES: string[] = Object.values(StartsOnLeftSelectValue);

export function isStartsOnLeftSelectValue(value: string): value is StartsOnLeftSelectValue {
	return STARTS_ON_LEFT_SELECT_VALUES.includes(value);
}
